module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-042f9f2a.png";